/* globals GIG */

'use strict';

const TTDPassViewDetailsModal = {
  init(payload, done) {
    const viewDetailsLinks = document.querySelectorAll('.modal-link');
    const { TTDPass } = payload;
    if (TTDPass) {
      const deals = [];
      const { states } = TTDPass;
      viewDetailsLinks.forEach(viewDetailsLink => {
        const deal = {
          dealUUID: viewDetailsLink.dataset.dealUuid,
          dealName:
            viewDetailsLink.parentElement.parentElement.parentElement
              .parentElement.firstElementChild.innerText,
        };
        deals.push(deal);
        viewDetailsLink.onclick = function changeContent(e) {
          const dealUUID = e.currentTarget.attributes['data-deal-uuid'].value;
          if (states) {
            states.selectedDealUUID = dealUUID;
          }
          GIG.Modal.open({ id: 'ttd-pass-view-details-modal' });
        };
      });
      states.deals = deals;
    }
    return done();
  },
};

module.exports = TTDPassViewDetailsModal;
